// extracted by mini-css-extract-plugin
export default {"dropdown":"DishesTableUnit_dropdown__Rp8ny","dropdownItems":"DishesTableUnit_dropdownItems__blG3G","placeHolderShimmer":"DishesTableUnit_placeHolderShimmer__R5kZt"};